import { Link } from "react-router-dom";

export default function AccountSetting() {
  return (
    <div  className="main-content">
      <div className="customer-part">
        <div className="card-box">
          <div className="notification-box">
            <h2 className="h3-headline mb-4">Account Settings</h2>
            <div className="notification-account">
              <ul className="notification-1">
                <li>
                  <Link to="/business/account-setting/edit-business-info">
                    <div className="notification-left">
                      <i className="fi fi-rr-user" />
                      <h6 className="h6-headline">Edit business info </h6>
                    </div>
                    <i className="fi fi-rr-arrow-small-right" />
                  </Link>
                </li>
                <li>
                  <Link to="/business/account-setting/edit-business-description">
                    <div className="notification-left">
                      <i className="fi fi-rr-memo" />
                      <h6 className="h6-headline">Business Description</h6>
                    </div>
                    <i className="fi fi-rr-arrow-small-right" />
                  </Link>
                </li>
                {/* <li>
                  <Link to="/business/account-setting/add-bank-details">
                    <div className="notification-left">
                      <i className="fi fi-rr-credit-card" />
                      <h6 className="h6-headline">Add Bank Details</h6>
                    </div>
                    <i className="fi fi-rr-arrow-small-right" />
                  </Link>
                </li> */}
                <li>
                  <Link to="/business/account-setting/edit-business-hours">
                    <div className="notification-left">
                      <i className="fi fi-rs-clock" />
                      <h6 className="h6-headline">Manage Operating Hours</h6>
                    </div>
                    <i className="fi fi-rr-arrow-small-right" />
                  </Link>
                </li>
                <li>
                  <Link to={"/business/account-setting/edit-location-details"}>
                    <div className="notification-left">
                      <i className="fi fi-rs-location-alt" />
                      <h6 className="h6-headline">Location Details</h6>
                    </div>
                    <i className="fi fi-rr-arrow-small-right" />
                  </Link>
                </li>
                <li>
                  <Link to={"/business/account-setting/manage-bank-account"}>
                    <div className="notification-left">
                      <i className="fi fi-rr-credit-card" />
                      <h6 className="h6-headline">Add Bank Details</h6>
                    </div>
                    <i className="fi fi-rr-arrow-small-right" />
                  </Link>
                </li>
                <li>
                  <Link to={"/business/account-setting/subscription"}>
                    <div className="notification-left">
                    <i className="ri-sticky-note-add-line"></i>
                      <h6 className="h6-headline">Manage Subscription</h6>
                    </div>
                    <i className="fi fi-rr-arrow-small-right" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
     
        </div>
      
      
      </div>
    </div>
  );
}
